import {
  CommentItem,
  LikeButton,
  CommentItemProps,
  CommentList,
  ReactionList,
  CommentField,
} from 'react-activity-feed';
import Button from '@mui/material/Button';
import ReplyIcon from '@mui/icons-material/Reply';

import TigerLikeButton from './TigerLikeButton';
import TigerNestedCommentField from './TigerNestedCommentField';
import TigerCommentItemActions from './TigerCommentItemActions';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

export default function TopLevelCommentItem({ comment }: CommentItemProps) {
  if (comment.children_counts?.comment > 0) {
    // NOTE: We clone the nested comments before reversing them because
    // https://stackoverflow.com/a/57569141/80426
    let nestedComments = [...comment.latest_children.comment];
    let resersedNestedComments = nestedComments.reverse();
    // console.log('DEBUG nestedComments ...', nestedComments);
    // console.log('DEBUG resersedNestedComments ...', resersedNestedComments);
    return (
      <>
        {/* <CommentList activityId={comment.id} /> */}
        <CommentItem comment={comment} />
        <TigerCommentItemActions comment={comment} parentComment={comment} />
        {/* TODO <CommentField activity={comment} placeholder='Write a NESTED comment' /> */}
        {resersedNestedComments.map((childComment, index) => {
          return (
            <>
              <Box sx={{ ml: 5 }} key={index}>
                <CommentItem comment={childComment} />
                <TigerCommentItemActions
                  comment={childComment}
                  parentComment={comment}
                  showSameLevelReply={true}
                />
              </Box>
            </>
          );
        })}
      </>
    );
  } else {
    return (
      <>
        <div>
          <CommentItem comment={comment} />
          <TigerCommentItemActions comment={comment} parentComment={comment} />
        </div>
      </>
    );
  }
}
